export default "__VITE_ASSET__NPZ6kulS__"